import { render, staticRenderFns } from "./SalesPeakCmp.vue?vue&type=template&id=8c533cd0&scoped=true&"
import script from "./SalesPeakCmp.vue?vue&type=script&lang=js&"
export * from "./SalesPeakCmp.vue?vue&type=script&lang=js&"
import style0 from "./SalesPeakCmp.vue?vue&type=style&index=0&id=8c533cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c533cd0",
  null
  
)

export default component.exports